module.exports = __webpack_public_path__ + "static/media/favorite.76c6dd48.svg";